import React, { useState, useEffect } from 'react';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const UserDetailsModal = ({ onSubmit, user }) => {
    const [isPinValid, setIsPinValid] = useState(true);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        pincode: '',
        address: '',
    });

    useEffect(() => {
        if (user) {
            setFormData({
                firstName: user.firstName || '',
                lastName: user.lastName || '',
                phone: user.phone || '',
                pincode: user.pincode || '',
                address: user.address || '',
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: name === 'pincode' ? parseInt(value, 10) || '' : value
        });

        if (name === 'pincode') {
            setIsPinValid(value.length === 6);
        }
    };

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, phone: value });
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        if (name === 'phone' && value.length > 10) {
            e.target.value = value.slice(0, 10);
        }
        if (name === 'pincode' && value.length > 6) {
            e.target.value = value.slice(0, 6);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const response = onSubmit(formData);
        console.log(response);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className='text-black text-3xl font-Poppins font-semibold text-center pb-2'>Additional Details</h2>
                <form onSubmit={handleSubmit} className='text-xl text-center'>
                    <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        className='w-full border-b mt-[15px] outline-none'
                        required
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        className='w-full border-b mt-[15px] outline-none'
                        required
                    />
                    <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        value={formData.address}
                        onChange={handleChange}
                        className='w-full border-b mt-[15px] outline-none'
                        required
                    />
                    <input
                        type="number"
                        name="pincode"
                        placeholder="Pincode"
                        minLength="6"
                        maxLength="6"
                        pattern="\d*"
                        inputMode="numeric"
                        value={formData.pincode}
                        onInput={handleInput}
                        onChange={handleChange}
                        className='w-full border-b mt-[15px] outline-none'
                        required
                    />
                    {!isPinValid && (
                        <p className='text-primary text-[12px] text-start'>
                            Pincode must be at least 6 digits
                        </p>
                    )}
                    <div className="w-full mt-[15px] border-b text-start">
                        <PhoneInput
                            country={"in"}
                            value={formData.phone}
                            onChange={handlePhoneChange}
                            inputStyle={{
                                width: "100%",
                                border: "none",
                                borderRadius: "0",
                                fontSize: "1.25rem",
                                paddingLeft: "48px",
                                height: "40px"
                            }}
                            containerStyle={{
                                border: "none",
                            }}
                            buttonStyle={{
                                background: "none",
                                border: "none",
                                borderRadius: "0",
                            }}
                        />
                    </div>
                    <div className="text-center">
                        <button type="submit" className='mt-[23px] text-lg font-semibold bg-primary hover:bg-primary/80 text-white rounded-xl px-10 py-1'>
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserDetailsModal;
